import { useCallback } from "react";
import { useParams } from "react-router-dom";

import SystemConfigTable from "~/components/siteSpeed/dns/SystemConfigTable";
import { UserConfigTable } from "~/components/siteSpeed/dns/UserConfigTable";
import { getBrandName } from "~/utils/white-label";

import { useWizard } from "../../../contexts/WizardContext";
import Spinner from "../../ui/spinner/Spinner";
import { useDomainWithDns } from "../hooks";
import styles from "./Wizzard.module.scss";

const DNS = () => {
  const { domainId } = useParams<{ domainId: string }>();

  if (!domainId) {
    throw new Error("No DomainId");
  }

  const { setStepError } = useWizard();
  const { data: domain, showInitialLoader } = useDomainWithDns(domainId);

  const handleErrorChange = useCallback(
    (hasError: boolean) => {
      setStepError("dns", hasError);
    },
    [setStepError],
  );

  const isFullIntegration = domain?.integration_type === "full";

  if (showInitialLoader || !domain) {
    return <Spinner />;
  }

  return (
    // @ts-expect-error TS2339 non-existing className
    <div className={styles.stepContent}>
      <div className={styles.stepContentTitle}>DNS configuration</div>
      <div className={styles.stepContentDescriptionText}>
        Copy A and CNAME DNS records for hostnames you want to enable AI
        Visibility Engine on.
      </div>
      <p className={styles.stepContentDescriptionDesc}>
        This information tells {getBrandName()} where to route the traffic to.
        To do so:
      </p>
      <ol className={styles.stepContentList}>
        <li>
          Sign in to your domain management dashboard (GoDaddy, Name.com, etc).
        </li>
        <li>Locate the DNS settings for {domain.name}.</li>
        <li>
          Find A and/or CNAME records associated with {domain.name}, and add
          them here.
        </li>
      </ol>

      <UserConfigTable
        domain={domain}
        isWizard
        onErrorChange={handleErrorChange}
      />
      {domain.system_config?.length && isFullIntegration && (
        <div className={styles.systemConfig}>
          <div className={styles.stepContentTitle}>
            Managed by {getBrandName()}
          </div>
          <SystemConfigTable domain={domain} />
        </div>
      )}
    </div>
  );
};
export default DNS;
